import { FormItem, TextInput } from '@framework/form';
import * as React from 'react';

export interface ITableSaveDirectiveConfigComponent {
  name: string;
}

/**
 * Campo di input per indicare in che campo della tabella salvare il valore.
 */
export function TableSaveDirectiveConfigComponent(
  props: ITableSaveDirectiveConfigComponent,
) {
  // const tableSave = useController({ name: props.name });

  return (
    <FormItem
      name={`${props.name}.name`}
      label="Salva in Tabella"
      help="Indica in che campo della tabella salvare il valore"
      style={{ marginBottom: 48 }}
    >
      <TextInput name={`${props.name}.name`} allowClear />
    </FormItem>
  );
}
